import React from "react";
import styles from "./DropdownItems.module.scss";

interface BasicDropdownItemsProps {
  option: any;
  value: string;
  onClick: (option: any) => void;
}

export const BasicDropdownItem: React.FC<BasicDropdownItemsProps> = ({
  option,
  value,
  onClick,
}) => {
  return (
    <div className={styles.BasicDropdownItem} onClick={() => onClick(option)}>
      {value}
    </div>
  );
};
